import { Card, IconButton } from '@folio/stripes/components';
import React, { useCallback } from 'react';
import { useFieldArray } from 'react-final-form-arrays';
import { FormattedMessage } from 'react-intl';
import { CriteriaCard } from './Criteria';
export default function ConditionalCard(_a) {
    var children = _a.children, conditionName = _a.conditionName, fieldArrayName = _a.fieldArrayName, _b = _a.patronOnly, patronOnly = _b === void 0 ? false : _b, index = _a.index;
    var fields = useFieldArray(fieldArrayName).fields;
    var handleMoveUpClick = useCallback(function () {
        fields.swap(index, index - 1);
    }, [fields, index]);
    var handleMoveDownClick = useCallback(function () {
        fields.swap(index, index + 1);
    }, [fields, index]);
    var handleRemoveClick = useCallback(function () {
        fields.remove(index);
    }, [fields, index]);
    return (React.createElement(Card, { headerStart: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.conditional.card.header" }), headerEnd: React.createElement(React.Fragment, null,
            React.createElement(IconButton, { icon: "caret-up", disabled: index === 0, onClick: handleMoveUpClick }),
            React.createElement(IconButton, { icon: "caret-down", disabled: index + 1 === fields.length, onClick: handleMoveDownClick }),
            React.createElement(IconButton, { icon: "trash", onClick: handleRemoveClick })) },
        React.createElement(CriteriaCard, { name: conditionName, alone: true, patronOnly: patronOnly }),
        children));
}
